// for now user in sard-ui only but replace in other apps too

import ClipboardJS from 'clipboard'

Ready(() => {
  // Boilerplate Markup can eventually be replaced with and this removed
  // :code
  //    .some-haml
  //      YEAH
  //
  document.querySelectorAll('.sa-code-snippet').forEach(snippet => {
    if (!snippet.closest('.sa-code-snippet-wrapper')) {
      const wrapper = document.createElement('div')
      wrapper.className = 'sa-code-snippet-wrapper'
      snippet.parentNode.insertBefore(wrapper, snippet)
      wrapper.appendChild(snippet)
    }

    if (!snippet.querySelector('button.copy-code-button')) {
      const button = document.createElement('button')
      button.className = 'copy-code-button'
      button.type = 'button'
      button.textContent = 'Copy'
      snippet.insertBefore(button, snippet.firstChild)
    }
  })

  const clipboard = new ClipboardJS('.copy-code-button', {
    target: (trigger) => trigger.parentNode.querySelector('code')
  })

  clipboard.on('success', (e) => {
    e.trigger.textContent = 'Copied!'

    setTimeout(() => {
      e.trigger.textContent = 'Copy'
    }, 2000)

    e.clearSelection()
  })

  // Prevent default button behavior that might cause scrolling
  document.addEventListener('click', (e) => {
    if (e.target.classList.contains('copy-code-button')) {
      e.preventDefault()
    }
  })
})
